<template>
  <div>
    <div id="govbar" class="govbar govbar-light"><a href="http://gouvernement.lu" target="_blank" class="govbar-logo"><img src="//cdn.public.lu/pictures/logos/gov/gov-light.png" alt="Gouvernement du Grand-Duché de Luxembourg"></a><ul class="govbar-links"><li><a class="govbar-link" href="http://luxembourg.lu/" target="_blank">luxembourg.lu</a></li><li><a class="govbar-link" href="http://guichet.lu/" target="_blank">guichet.lu</a></li><li><a class="govbar-link" href="http://gouvernement.lu/" target="_blank">gouvernement.lu</a></li><li><a class="govbar-link govbar-more" href="http://etat.lu/" title="L’annuaire des sites internets publics luxembourgeois" target="_blank">Autres sites</a></li></ul></div>
    <header class="bg-grey-light py-2 text-center text-sm-left">
        <nav class="nav">
              <a class="navbar-brand" href="#">
                  <img src="@/assets/geoportail-logo.svg" alt="">
              </a>
              <div class="navbar-nav flex-row flex-wrap ms-md-auto">
                <LocaleSwitcher />
                &nbsp;
                <button class="btn btn-primary" :class="!isConnected?'disabled':''" @click="disconnect">{{$t('Déconnexion')}}</button>
              </div>
        </nav>
    </header>
  </div>
</template>

<script>
import LocaleSwitcher from '@/components/LocaleSwitcher.vue'
import {inject, ref} from 'vue';
export default {
  name: 'Header',
  components: {
    LocaleSwitcher
  },
  setup() {
    const emitter = inject('emitter');
    const isConnected = ref(false);
    emitter.on('disconnect', function() {
      isConnected.value = false;
    });
    emitter.on('connect', function() {
      isConnected.value = true;
    });
    const disconnect = function() {
      let formData = new FormData();
        fetch("api/logout", {
            body: formData,
            method: "post"
        }).then(function() {
          emitter.emit('disconnect', {})
        }.bind(this));
      }
   return {
     disconnect,
     isConnected
   }
  }
}
</script>
<style scoped>
.govbar{border-bottom:1px solid #cccaca;font-family:Arial,sans-serif;font-size:12px;position:relative;z-index:30000;*zoom:1}.govbar:after{clear:both;content:'';display:table}.govbar-light{background:#fff}.govbar-light .govbar-link{color:#222!important}.govbar-light .govbar-link:hover,.govbar-light .govbar-link:focus{background:#e6e6e6}.govbar-dark{background:#333}.govbar-dark .govbar-link{color:#ddd!important}.govbar-dark .govbar-link:hover,.govbar-dark .govbar-link:focus{background:#666}.govbar-logo{border:0;float:left;padding:3px 8px;vertical-align:middle}.govbar-logo img{border:0;display:block;height:40px}.govbar-links{float:right;list-style:none;line-height:30px;margin:0;padding:0}.govbar-links li{float:left}.govbar-link{border:0;float:left;font-weight:bold;min-height:30px;padding:8px;text-decoration:none}.govbar-more{font-weight:normal}@media only screen and (max-width:45em){.govbar-logo,.govbar-logo>img{float:none;display:block;margin:0 auto}.govbar-links{display:none;float:none}.govbar-links:target{display:block}}
</style>

